import { Component, OnInit, OnDestroy, Optional, Injectable, Input, ChangeDetectorRef } from '@angular/core'
import { GSBaseControl } from './gs.base.control';
import { Item } from '../entity/entities';
import { FormNumberDecimalProperty } from '../entity/form/formNumberDecimal.property';
import { TableColumn } from '../entity/table/tableColumn';

@Component({
  selector: 'gs-input-decimal',
  templateUrl: './gs.inputDecimal.control.html'
})
@Injectable()
export class GSInputDecimalControl extends GSBaseControl implements OnInit, OnDestroy {
  //#region -------Properties
  @Input() forceReadonly = false;
  @Input() column: TableColumn;
  @Input() item: any;
  public stringItem = { stringVal: '' };
  //#endregion

  //#region -------Constructor
  constructor(@Optional() prop: FormNumberDecimalProperty, @Optional() item: Item, private changeDr: ChangeDetectorRef) {
        super(changeDr);
        this.property = prop;
        this.item = item;
    }
  //#endregion

  //#region -------NG Eents
  ngOnInit() {
  }

  ngOnDestroy() {
  }
  //#endregion

  //#region -------UI Events
  change(e) {
    if (e || e == '') {
      let previousValue = this.data[this.name];
      //this.value = e; //value is set in decimal.ts directive!!!! here it would be set to string, not decimal!!!!!
      this.item.reCheckDirty();
      if (this.property) {
        this.onChange.emit({ propertyName: this.name, previousValue: previousValue, newValue: this.value, event: e, item: this.item, property: this.property });
        this.property.changed.emit({ propertyName: this.name, previousValue: previousValue, newValue: this.value, event: e, item: this.item, property: this.property });
      }
      else if (this.column && (!isNaN(parseFloat(e)) || (e === '' && this.column.emitOnEmpty))) {
        // Normally a cleared cell (empty string) emits nothing, so row-change listeners
        // never re-run. Columns flagged emitOnEmpty opt in to emitting on clear so their
        // cross-cell validation (e.g. check balancing) does not keep a stale, pre-clear
        // result and stay valid when it should not.
        this.onChange.emit({ propertyName: this.column.name, previousValue: previousValue, newValue: this.value, event: e, item: this.item, column: this.column });
      }
    }
  }


  //#endregion

  //#region -------Private
  //#endregion
}
